export enum ErrorMessageType {
  Storage,
  Filesystem,
  Connection,
  NotSynced,
  Unknown
}
